import { isString } from 'lodash';

import { FormContextValues } from '@dreryk/react-common';
import { TextInput } from '@dreryk/react-components';

import { translationKeys } from '../../translations';

const NFZ_MFA_TOTP_FIELD_NAME = 'mfaTotp';
const NFZ_MFA_TOTP_MIN_LENGTH = 6;
const NFZ_MFA_TOTP_MAX_LENGTH = 6;
const NFZ_MFA_TOTP_PATTERN = /^\d{6}$/u;

export type NfzMfaTotpFieldFormBeanPart = { [NFZ_MFA_TOTP_FIELD_NAME]: string | null };

type NfzMfaTotpFieldProps = Pick<FormContextValues<NfzMfaTotpFieldFormBeanPart>, 'register'>;

export const NfzMfaTotpField = (props: NfzMfaTotpFieldProps): JSX.Element => {
   return (
      <TextInput
         placeholder={translationKeys.mfaModal.totpFieldPlaceholder}
         controller={props.register(NFZ_MFA_TOTP_FIELD_NAME, {
            required: true,
            minLength: NFZ_MFA_TOTP_MIN_LENGTH,
            maxLength: NFZ_MFA_TOTP_MAX_LENGTH,
            validate: (value) => {
               if (isString(value) && !NFZ_MFA_TOTP_PATTERN.test(value)) {
                  return translationKeys.mfaModal.invalidCodeFormatError;
               }

               return undefined;
            },
         })}
         testId={NFZ_MFA_TOTP_FIELD_NAME}
      />
   );
};
